export default __webpack_public_path__ + "2be3d19c6710d5eebb43d8008745e725.png";